import {
	type AlertColor,
	AlertTitle,
	Box,
	Fade,
	type FadeProps,
	Alert as MuiAlert,
	Snackbar,
	type SxProps,
	type Theme,
	Typography,
} from '@mui/material';
import React, { memo, useState } from 'react';

import { customSizes, spaces } from '../../assets/styles/themes/tokens';
import { alertDuration } from '../../constants';

interface OwnProps {
	message: string;
	description?: string;
	onClose?: () => void;
	severity?: AlertColor;
	alertSx?: SxProps<Theme>;
}

export type Alert = {
	message: string;
	description?: string;
	severity: AlertColor;
};

const NotificationAlert: React.FC<OwnProps> = (props) => {
	const [isOpen, setIsOpen] = useState(true);
	const { message, description, onClose, severity = 'success', alertSx } = props;

	const handleOnClose = () => {
		if (isOpen) {
			// We don't want onClose to execute twice
			setIsOpen(false);
			if (onClose) onClose();
		}
	};

	const CustomFadeTransition = (props: FadeProps) => {
		return <Fade {...props} />;
	};

	return (
		<Snackbar
			open={isOpen}
			autoHideDuration={alertDuration}
			onClose={handleOnClose}
			TransitionComponent={CustomFadeTransition}
			sx={{
				position: 'absolute',
				height: 'min-content',
				top: `${customSizes.readerPage.paddingY} !important`,
				left: '0 !important',
				right: '0 !important',
				bottom: '0 !important',
			}}
		>
			<MuiAlert
				data-testid="notification-alert"
				severity={severity}
				onClose={handleOnClose}
				sx={{
					borderRadius: spaces.sm,
					alignItems: description ? 'flex-start' : 'center',
					...alertSx,
				}}
			>
				{description ? (
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							color: 'inherit',
						}}
					>
						<AlertTitle color="inherit">{message}</AlertTitle>
						<Typography variant="body2" color="inherit">
							{description}
						</Typography>
					</Box>
				) : (
					message
				)}
			</MuiAlert>
		</Snackbar>
	);
};

export default memo(NotificationAlert);
